import { Box } from '@mui/system';
import React, { Suspense, useMemo } from 'react';
import { LogoMark } from '@/components/WelligenceLogo/WelligenceLogoSVG';
import { styles } from './styles';

const Form = React.lazy(() => import(/* webpackChunkName: "form" */ './components/Form'));

const LazyLoadedForm = () => {
  const token = useMemo(() => {
    if (typeof window === 'undefined') {
      return '';
    }
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('token') ?? '';
  }, []);
  return (
    <Suspense fallback={<div style={styles.loadingForm}>Loading...</div>}>
      <Form token={token} />
    </Suspense>
  );
};

const SignUp = () => {
  return (
    <Box
      component='main'
      display='grid'
      gridTemplateColumns={{
        md: '1fr clamp(18rem, 90dvw, 48rem)',
        sm: '1fr',
      }}
      justifyContent='center'
      sx={styles.pageContainer}
    >
      <Box
        sx={styles.formWrapper}
        display='grid'
        gap='1'
        gridColumn={{
          md: '2/3',
        }}
        gridTemplateColumns='2rem clamp(10rem, calc(98% - 4rem), 45rem) 2rem'
        gridTemplateRows='auto 1fr'
        justifyContent='center'
      >
        <figure style={styles.logo}>
          <LogoMark />
        </figure>
        <LazyLoadedForm />
      </Box>
    </Box>
  );
};

export default SignUp;
